<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="img-upload">
            <span @click="$refs.headPhoto.$el.querySelector('input').click()">
              <i class="fa fa-camera" aria-hidden="true"></i>
              <el-upload
                ref="headPhoto"
                class="uploadFile img"
                style="width: 0px; height: 0px; overflow: hidden"
                action
                accept=".jpg,.jpeg,.png"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="uploadHeadPhoto"
                :limit="1"
              >
              </el-upload>
            </span>
            <div
              v-if="headPhotoBase64"
              class="imagePreview"
              :style="{
                'background-image': 'url(' + headPhotoBase64 + ')',
              }"
            />
            <div v-else class="imagePreview" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  中文姓名
                  <span class="en-text">Chinese name</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.Name"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <!-- 性別 -->
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  性別
                  <span class="en-text">Gender</span>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input type="radio" :value="0" v-model="baseInfo.Sex" />
                  <span>男 (Male)</span>
                </label>
                <label>
                  <input type="radio" :value="1" v-model="baseInfo.Sex" />
                  <span>女 (Female)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  應徵工作班別 (可複選)
                  <span class="en-text">
                    Apply work shift (Can select many)
                  </span>
                </span>
              </div>
              <div class="field-value">
                <el-checkbox-group v-model="baseInfo.WorkShiftTypes">
                  <el-checkbox label="D班 shift（07：00~19：05）"></el-checkbox>
                  <el-checkbox label="N班 shift（19：00~07：05）"></el-checkbox>
                </el-checkbox-group>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 生日 -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              name="生日"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  生日
                  <span class="en-text">Date of birth</span>
                </span>
              </div>
              <div class="field-value">
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="{
                    disabledDate: $common.disabledDateAfterToday,
                  }"
                  placeholder="YYYY-MM-DD"
                  v-model="baseInfo.BirthDay"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 國籍 -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              name="國籍"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  國籍
                  <span class="en-text">Nationality</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請選擇"
                  v-model="baseInfo.NationalityGuid"
                >
                  <el-option
                    v-for="country in countryOptions"
                    :key="country.Guid"
                    :label="country.Name"
                    :value="country.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <template
          v-if="
            baseInfo.NationalityGuid !== '99999999-9999-9999-9999-999999999999'
          "
        >
          <div
            :class="baseInfo.ForeignerReason === 3 ? 'col-md-6' : 'col-md-12'"
          >
            <div class="field">
              <ValidationProvider
                name="外籍在台原因"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    外籍在台原因
                    <span class="en-text">Reason why foreigner in Taiwan</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="baseInfo.ForeignerReason"
                  >
                    <el-option
                      label="依親在台 Relative in Taiwan"
                      :value="0"
                    ></el-option>
                    <el-option
                      label="工作在台 Work in Taiwan"
                      :value="1"
                    ></el-option>
                    <el-option
                      label="就學在台 Education at Taiwan"
                      :value="2"
                    ></el-option>
                    <el-option
                      label="其他原因在台 Other reason at Taiwan"
                      :value="3"
                    ></el-option>
                    <el-option
                      label="仲介選工 Manpower agency select workers"
                      :value="4"
                    ></el-option>
                  </el-select>
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="baseInfo.ForeignerReason === 3"
            :class="baseInfo.ForeignerReason === 3 ? 'col-md-6' : 'col-md-6'"
          >
            <div class="field">
              <ValidationProvider
                name="備註"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    備註
                    <span class="en-text">Remark</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-input
                    class="w-100"
                    v-model="baseInfo.ForeignerReasonDesc"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </template>

        <!-- 身分證字號/護照號碼 -->
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                身分證字號/護照號碼
                <span class="en-text">ID no./Passport no.</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="20"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="baseInfo.IdNo"
              />
            </div>
          </div>
        </div>

        <!-- 手機 -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              name="手機"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  手機
                  <span class="en-text">Cellphone</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.MobilePhone"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- E-mail -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              name="E-mail"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }"> E-mail </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.Email"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 家用電話 -->
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                家用電話(區域碼-號碼)
                <span class="en-text">Family Phone</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="50"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="baseInfo.Phone"
              />
            </div>
          </div>
        </div>

        <!-- 身高(cm) -->
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                身高(cm)
                <span class="en-text">Height(cm)</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="999.9"
                @input="
                  baseInfo.Height = $common.oneDecimalPlace(baseInfo.Height)
                "
                v-model="baseInfo.Height"
              />
            </div>
          </div>
        </div>
        <!-- 體重(kg) -->
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                體重(kg)
                <span class="en-text">Weight(kg)</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="999.9"
                @input="
                  baseInfo.Weight = $common.oneDecimalPlace(baseInfo.Weight)
                "
                v-model="baseInfo.Weight"
              />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                配合加班
                <span class="en-text">Cooperate with overtime</span>
              </span>
            </div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="baseInfo.CanOverTime"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="baseInfo.CanOverTime"
                  />
                  <span>否 (No)</span>
                </label>
              </div>

              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              :rules="{ required: !baseInfo.CanOverTime ? true : false }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!baseInfo.CanOverTime" class="mark">*</span>
                <span :style="{ color: fontColor }">
                  原因說明
                  <span class="en-text">Reason</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.CanOverTimeDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                配合輪班
                <span class="en-text">Cooperate with shift rotation</span>
              </span>
            </div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="baseInfo.CanShiftWork"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="baseInfo.CanShiftWork"
                  />
                  <span>否 (No)</span>
                </label>
              </div>

              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              :rules="{ required: !baseInfo.CanShiftWork ? true : false }"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span v-if="!baseInfo.CanShiftWork" class="mark">*</span>
                <span :style="{ color: fontColor }">
                  原因說明
                  <span class="en-text">Reason</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.CanShiftWorkDesc"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                領有身心障礙手冊
                <span class="en-text"> Do you have a disability booklet </span>
              </span>
            </div>
            <div class="field-radio">
              <label>
                <input
                  type="radio"
                  :value="true"
                  v-model="baseInfo.HasDisabilityCard"
                />
                <span>是 (Yes)</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="false"
                  v-model="baseInfo.HasDisabilityCard"
                />
                <span>否 (No)</span>
              </label>
            </div>
          </div>
        </div>

        <div v-if="baseInfo.HasDisabilityCard" class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                身心障礙手冊-說明
                <span class="en-text"> Disability Memo </span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="200"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="baseInfo.HasDisabilityCardDesc"
              />
            </div>
          </div>
        </div>
        <!-- 住處 -->
        <div :class="baseInfo.HasDisabilityCard ? 'col-md-3' : 'col-md-6'">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  住處
                  <span class="en-text">Residence</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="baseInfo.ResidenceType"
                >
                  <el-option label="住家裡 (Own house)" :value="0"></el-option>
                  <el-option
                    label="親友提供 (Relative/Friend)"
                    :value="1"
                  ></el-option>
                  <el-option label="在外租屋 (Rent)" :value="2"></el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 出勤方式 -->
        <div :class="baseInfo.HasDisabilityCard ? 'col-md-3' : 'col-md-6'">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                出勤方式
                <span class="en-text">Method of transport</span>
              </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="baseInfo.CommutingType"
              >
                <el-option label="步行 (walk)" :value="0" />
                <el-option label="機車 (scooter)" :value="1" />
                <el-option label="汽車 (car)" :value="2" />
                <el-option label="腳踏車 (bicycle)" :value="3" />
                <el-option
                  label="大眾運輸 (public transportation)"
                  :value="4"
                />
              </el-select>
            </div>
          </div>
        </div>
        <!-- 通勤時間(分鐘) -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  通勤時間(分鐘)
                  <span class="en-text"> Commuting time (minutes)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="number"
                  min="0"
                  max="9999"
                  step="1"
                  v-model="baseInfo.CommutingMinutes"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 視力 -->
        <div :class="baseInfo.VisualAcuity === 999 ? 'col-md-3' : 'col-md-6'">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                視力
                <span class="en-text">Eyesight</span>
              </span>
            </div>
            <div class="field-value">
              <el-select
                class="w-100"
                placeholder="請選擇"
                v-model="baseInfo.VisualAcuity"
              >
                <el-option label="正常 (Normal)" :value="0" />
                <el-option label="雷射矯正 (Laser correction)" :value="1" />
                <el-option label="近視 (Near sighted)" :value="2" />
                <el-option label="遠視 (Far sighted)" :value="3" />
                <el-option label="其他 (Other)" :value="999" />
              </el-select>
            </div>
          </div>
        </div>

        <div
          v-if="baseInfo.VisualAcuity === 999"
          :class="baseInfo.VisualAcuity === 999 ? 'col-md-3' : 'col-md-6'"
        >
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                視力(說明)
                <span class="en-text">Eyesight Description</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="50"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="baseInfo.VisualAcuityDesc"
              />
            </div>
          </div>
        </div>

        <!-- 左眼度數 -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                左眼度數
                <span class="en-text">Left eye nearsighted</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="9999"
                step="1"
                @input="
                  baseInfo.SPHLeft = $common.positiveIntPlaces(baseInfo.SPHLeft)
                "
                v-model="baseInfo.SPHLeft"
              />
            </div>
          </div>
        </div>

        <!-- 右眼度數 -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                右眼度數
                <span class="en-text">Right eye nearsighted</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="9999"
                step="1"
                @input="
                  baseInfo.SPHRight = $common.positiveIntPlaces(
                    baseInfo.SPHRight
                  )
                "
                v-model="baseInfo.SPHRight"
              />
            </div>
          </div>
        </div>

        <!-- 是否有散光 -->
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                是否有散光
                <span class="en-text">Do you have astigmatism</span>
              </span>
            </div>
            <div class="field-radio">
              <label>
                <input
                  type="radio"
                  :value="true"
                  v-model="baseInfo.HasAstigmatic"
                />
                <span>是 (Yes)</span>
              </label>
              <label>
                <input
                  type="radio"
                  :value="false"
                  v-model="baseInfo.HasAstigmatic"
                />
                <span>否 (No)</span>
              </label>
            </div>
          </div>
        </div>
        <!-- 左眼散光度數 -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                左眼散光度數
                <span class="en-text">Left eye astigmatism</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="9999"
                step="1"
                @input="
                  baseInfo.CYLLeft = $common.positiveIntPlaces(baseInfo.CYLLeft)
                "
                v-model="baseInfo.CYLLeft"
              />
            </div>
          </div>
        </div>
        <!-- 右眼散光度數 -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                右眼散光度數
                <span class="en-text">Right eye astigmatism</span>
              </span>
            </div>
            <div class="field-value">
              <input
                type="number"
                min="0"
                max="9999"
                step="1"
                @input="
                  baseInfo.CYLRight = $common.positiveIntPlaces(
                    baseInfo.CYLRight
                  )
                "
                v-model="baseInfo.CYLRight"
              />
            </div>
          </div>
        </div>

        <!-- 通訊地址(縣市) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  通訊地址(縣市)
                  <span class="en-text">Mailing address(City)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請選擇"
                  @change="changeCity('ContactCountyGuid')"
                  v-model="baseInfo.ContactCountyGuid"
                >
                  <el-option
                    v-for="city in cityOptions"
                    :key="city.Guid"
                    :label="city.Name"
                    :value="city.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 通訊地址(區) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  通訊地址(區)
                  <span class="en-text">Mailing address(District)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  v-model="baseInfo.ContactDistrictGuid"
                >
                  <el-option
                    v-for="district in contactDistrictOptions"
                    :key="district.Guid"
                    :label="district.Name"
                    :value="district.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 通訊地址(村里) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider
              :rules="source === 'personnelInformation' ? 'required' : null"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span v-if="source === 'personnelInformation'" class="mark"
                    >*</span
                  >
                  通訊地址(村里)
                  <span class="en-text">Mailing address(Village)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.ContactVillage"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 通訊地址 -->
        <div class="col-md-3">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  通訊地址
                  <span class="en-text">Mailing address</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.ContactAddress"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 戶籍地址(縣市) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  戶籍地址(縣市)
                  <span class="en-text">Household address (City)</span><br />
                  <input
                    type="checkbox"
                    style="margin-right: 2px"
                    v-model="householdSameAddress"
                  />
                  同通訊地址
                  <span class="en-text">Same as mailing address</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  @change="changeCity('CountyGuid')"
                  v-model="baseInfo.CountyGuid"
                >
                  <el-option
                    v-for="city in cityOptions"
                    :key="city.Guid"
                    :label="city.Name"
                    :value="city.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 戶籍地址(區) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  戶籍地址(區)<br />
                  <span class="en-text">Household address(District)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  v-model="baseInfo.DistrictGuid"
                >
                  <el-option
                    v-for="district in householdDistrictOptions"
                    :key="district.Guid"
                    :label="district.Name"
                    :value="district.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 戶籍地址(村里) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider
              :rules="source === 'personnelInformation' ? 'required' : null"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span v-if="source === 'personnelInformation'" class="mark"
                    >*</span
                  >
                  戶籍地址(村里)<br />
                  <span class="en-text">Household address(Village)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.Village"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 戶籍地址 -->
        <div class="col-md-3">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  戶籍地址<br />
                  <span class="en-text">Household address</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.Address"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 緊急聯絡人姓名 -->
        <div class="col-md-3">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  緊急聯絡人姓名<br />
                  <span class="en-text">Emergency contact name</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.EmergencyContact"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 關係 -->
        <div class="col-md-3">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  關係<br />
                  <span class="en-text">Relationship</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.EmergencyContactRelationship"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 緊急聯絡人電話(手機) -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  緊急聯絡人電話(手機) <br />
                  <span class="en-text">
                    Emergency contact person phone no.(cell phone)
                  </span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.EmergencyContactPhone"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 聯絡人地址(縣市) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  聯絡人地址(縣市)
                  <span class="en-text">Contact address(City)</span><br />
                  <input
                    type="checkbox"
                    style="margin-right: 2px"
                    :disabled="contactSameHousehold"
                    v-model="contactSameAddress"
                  />
                  同通訊地址
                  <span class="en-text">Same as mailing address</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  @change="changeCity('EmergencyContactCountyGuid')"
                  v-model="baseInfo.EmergencyContactCountyGuid"
                >
                  <el-option
                    v-for="city in cityOptions"
                    :key="city.Guid"
                    :label="city.Name"
                    :value="city.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 聯絡人地址(區) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  聯絡人地址(區)
                  <span class="en-text">Contact address(District)</span><br />
                  <input
                    type="checkbox"
                    style="margin-right: 2px"
                    :disabled="contactSameAddress"
                    v-model="contactSameHousehold"
                  />
                  同戶籍地址
                  <span class="en-text">Same as household address</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  v-model="baseInfo.EmergencyContactDistrictGuid"
                >
                  <el-option
                    v-for="district in emergencyDistrictOptions"
                    :key="district.Guid"
                    :label="district.Name"
                    :value="district.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 聯絡人地址(村里) -->
        <div class="col-md-3 col-sm-12">
          <div class="field">
            <ValidationProvider
              :rules="source === 'personnelInformation' ? 'required' : null"
              v-slot="{ errors }"
            >
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span v-if="source === 'personnelInformation'" class="mark"
                    >*</span
                  >
                  聯絡人地址(村里)<br />
                  <span class="en-text">Contact address(Village)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.EmergencyContactVillage"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>
        <!-- 聯絡人地址 -->
        <div class="col-md-3">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  <span class="mark">*</span>
                  聯絡人地址<br />
                  <span class="en-text">Contact address</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="200"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="baseInfo.EmergencyContactAddress"
                />
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 升學或進修的計畫 -->
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  目前是否在學或計劃於短期繼續升學或進修？
                  <p class="en-text">
                    Are you currently studying or planning to continue further
                    studies in the short term period?
                  </p>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input
                    type="radio"
                    :value="true"
                    v-model="baseInfo.InSchoolOrHasStudyPlan"
                  />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input
                    type="radio"
                    :value="false"
                    v-model="baseInfo.InSchoolOrHasStudyPlan"
                  />
                  <span>否 (No)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <!-- 請詳述計畫內容 -->
        <div class="col-md-6" v-if="baseInfo.InSchoolOrHasStudyPlan">
          <div class="field">
            <div class="field-title">
              <span :style="{ color: fontColor }">
                請詳述計畫內容
                <p class="en-text">Please elaborate plan content</p>
              </span>
            </div>
            <div class="field-value">
              <input
                type="text"
                maxlength="200"
                autocomplete="off"
                readonly
                @focus="$common.removeReadonly($event)"
                v-model="baseInfo.InSchoolOrHasStudyPlanDesc"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveBaseInfo)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId", "changePage", "person"],
  name: "AseDLBaseInfo",

  data() {
    return {
      baseInfo: {
        WorkShiftTypes: [], //需預設給陣列不然會是true跟false
      },
      householdSameAddress: false,
      contactSameAddress: false,
      contactSameHousehold: false,
      // 通訊
      contactDistrictOptions: [],
      // 戶籍
      householdDistrictOptions: [],
      // 聯絡人
      emergencyDistrictOptions: [],

      // 大頭照
      fileGuid: null,
      headPhotoBase64: null,
      resetFileStatus: true,

      backgroundColor: "#f1f1f1",
      fontColor: "#000",

      // 行政區快取：CountyGuid -> districts[]
      districtCache: {},
    };
  },

  methods: {
    // 儲存 個人資料
    saveBaseInfo() {
      this.$api.dl
        .putBaseInfo(this.source, {
          ...this.baseInfo,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "個人資料儲存成功",
              type: "success",
              duration: 2000,
            });

            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            } else if (this.changePage) {
              this.$router.push({
                path: "/manager/progress/personaldocument",
                query: {
                  matchId: this.matchId,
                  personData: JSON.stringify({
                    Name: this.person.Name,
                    Position: this.person.Position,
                  }),
                },
              });
            }

            this.getBaseInfo();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 個人資料
    getBaseInfo() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.dl.getBaseInfo(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.baseInfo = response.data;
          if (this.baseInfo.PhotoFileGroupId) {
            this.getHeadPhoto(this.baseInfo.PhotoFileGroupId);
          }
        }
        this.updateLoading(false);
      });
    },

    // 上傳 大頭照
    uploadHeadPhoto(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$notify({
          title: "失敗",
          message: "圖檔大小不得超過5MB",
          type: "error",
          duration: 3500,
        });
        this.$refs.headPhoto.clearFiles();
        return false;
      }

      this.updateLoading(true);

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileGroupGuid", this.baseInfo.PhotoFileGroupId);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.baseInfo.PhotoFileGroupId = response.data;
          this.$refs.headPhoto.clearFiles();
          this.resetFileStatus = false;
          this.fileGuid
            ? this.removeHeadPhoto()
            : this.getHeadPhoto(this.baseInfo.PhotoFileGroupId);
        }
      });
    },

    // 刪除 原本大頭照
    removeHeadPhoto() {
      this.$api.file.removeFile(this.fileGuid).then((response) => {
        if (response.status === 200) {
          this.getHeadPhoto(this.baseInfo.PhotoFileGroupId);
        }
      });
    },

    // 取得 大頭照
    getHeadPhoto(photoFileGroupId) {
      this.$api.file
        .getResumeHeadPhoto({
          resetFileStatus: this.resetFileStatus,
          photoFileGroupId: photoFileGroupId,
        })
        .then((response) => {
          if (response.status === 200) {
            this.fileGuid = response.data.FileGuid;
            this.headPhotoBase64 = response.data.HeadPhotoBase64;
          }
        });
    },

    // 依 CountyGuid 取得行政區（快取 Promise，避免併發時重複呼叫）
    fetchDistricts(countyGuid) {
      if (!countyGuid) return Promise.resolve([]);
      if (!this.districtCache[countyGuid]) {
        const promise = this.$api.address
          .getDistrict({ CountyGuid: countyGuid })
          .then((res) =>
            res.data.map((item) => ({ Guid: item.Guid, Name: item.Name }))
          )
          .catch((err) => {
            // 失敗則清掉快取，允許後續重試
            this.$delete(this.districtCache, countyGuid);
            throw err;
          });
        this.$set(this.districtCache, countyGuid, promise);
      }
      return this.districtCache[countyGuid];
    },

    // 變更縣市
    changeCity(name) {
      if (name === "ContactCountyGuid") {
        this.baseInfo.ContactDistrictGuid = null;
      } else if (name === "CountyGuid") {
        this.baseInfo.DistrictGuid = null;
      } else {
        this.baseInfo.EmergencyContactDistrictGuid = null;
      }
    },

    async getData() {
      this.updateLoading(true);
      // 取得 國籍
      await this.$store.dispatch("GetCountry");
      // 取得 縣市
      await this.$store.dispatch("GetCity");
      // 取得 基本資料
      await this.getBaseInfo();
      this.updateLoading(false);
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    // 戶籍地址同通訊地址
    householdSameAddress: function (newVal) {
      if (newVal) {
        this.baseInfo.CountyGuid = this.baseInfo.ContactCountyGuid;
        this.baseInfo.DistrictGuid = this.baseInfo.ContactDistrictGuid;
        this.baseInfo.Village = this.baseInfo.ContactVillage;
        this.baseInfo.Address = this.baseInfo.ContactAddress;
      } else {
        this.baseInfo.CountyGuid = null;
        this.baseInfo.DistrictGuid = null;
        this.baseInfo.Village = null;
        this.baseInfo.Address = null;
      }
    },

    // 聯絡人地址同通訊地址
    contactSameAddress: function (newVal) {
      if (newVal) {
        this.baseInfo.EmergencyContactCountyGuid =
          this.baseInfo.ContactCountyGuid;
        this.baseInfo.EmergencyContactDistrictGuid =
          this.baseInfo.ContactDistrictGuid;
        this.baseInfo.EmergencyContactVillage = this.baseInfo.ContactVillage;
        this.baseInfo.EmergencyContactAddress = this.baseInfo.ContactAddress;
      } else {
        this.baseInfo.EmergencyContactCountyGuid = null;
        this.baseInfo.EmergencyContactDistrictGuid = null;
        this.baseInfo.EmergencyContactVillage = null;
        this.baseInfo.EmergencyContactAddress = null;
      }
    },

    // 聯絡人地址同戶籍地址
    contactSameHousehold: function (newVal) {
      if (newVal) {
        this.baseInfo.EmergencyContactCountyGuid = this.baseInfo.CountyGuid;
        this.baseInfo.EmergencyContactDistrictGuid = this.baseInfo.DistrictGuid;
        this.baseInfo.EmergencyContactVillage = this.baseInfo.Village;
        this.baseInfo.EmergencyContactAddress = this.baseInfo.Address;
      } else {
        this.baseInfo.EmergencyContactCountyGuid = null;
        this.baseInfo.EmergencyContactDistrictGuid = null;
        this.baseInfo.EmergencyContactVillage = null;
        this.baseInfo.EmergencyContactAddress = null;
      }
    },

    // 國籍如果為中華民國，外籍在台原因為空
    "baseInfo.NationalityGuid": function (newVal) {
      if (newVal === "99999999-9999-9999-9999-999999999999") {
        this.baseInfo.ForeignerReason = null;
        this.baseInfo.ForeignerReasonDesc = null;
      }
    },

    // 通訊地址(縣市)
    "baseInfo.ContactCountyGuid": async function (newVal) {
      this.contactDistrictOptions = await this.fetchDistricts(newVal);
    },

    // 戶籍地址(縣市)
    "baseInfo.CountyGuid": async function (newVal) {
      this.householdDistrictOptions = await this.fetchDistricts(newVal);
    },

    // 聯絡人地址(縣市)
    "baseInfo.EmergencyContactCountyGuid": async function (newVal) {
      this.emergencyDistrictOptions = await this.fetchDistricts(newVal);
    },
  },

  computed: {
    ...mapGetters(["countryOptions", "cityOptions"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getData();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #5b5b5b;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #18c58b;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #18c58b;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #18c58b;
  border-color: #18c58b;
}

/deep/ .el-checkbox__label {
  font-size: 0.9rem;
}
</style>
